<template>
  <div class="house-importer-import-saldo-month-panel">
    <app-panel title="Импорт сальдо по месяцам">
      <div v-if="!isLoading && !isDone" class="house-importer-import-saldo-month-panel__content">
        <div class="house-importer-import-saldo-month-panel__main-content">
          <div class="house-importer-import-saldo-month-panel__panel-file house-importer-import-saldo-month-panel__panel-col">
            <div style="text-align: center; line-height: 1.1; font-size: 12px; text-transform: uppercase; color: rgba(var(--app-warning), 1);">
              Внимание! Имя файла должно иметь формат YYYY-MM.xlsx
            </div>

            <div class="house-importer-import-saldo-month-panel__no-file-error" v-if="filesError">
              Выберите хотя бы один файл
            </div>

            <vs-upload
                    action="#"
                    :limit="72"
                    :show-upload-button="false"
                    :multiple="true"
                    text="Добавить файлы"
                    class="w-auto mx-auto house-importer-import-saldo-month-panel__uploader house-importer-import-saldo-month-panel__uploader_multiple"
                    @change="onFilesChange"
                    @on-delete="onFilesDelete"
                    ref="chargesUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="house-importer-import-saldo-month-panel__panel-settings house-importer-import-saldo-month-panel__panel-col">
            <div class="house-importer-import-saldo-month-panel__panel-settings-row">
              <app-input label="Номер первого ряда с данными"
                         vtype="uint"
                         v-model="postBody.data_row"
                         :danger.sync="postBodyErrors.data_row"
                         danger-text="Заполните номер ряда"

              />
            </div>
            <div class="house-importer-import-saldo-month-panel__panel-settings-row">
              <app-input label="Номер колонки с начальным сальдо"
                         vtype="uint"
                         v-model="postBody.st_sal_col"
                         :danger.sync="postBodyErrors.st_sal_col"
                         danger-text="Заполните номер колонки"

              />
            </div>
            <div class="house-importer-import-saldo-month-panel__panel-settings-row">
              <app-input label="Номер колонки с конечным сальдо"
                         vtype="uint"
                         v-model="postBody.end_sal_col"
                         :danger.sync="postBodyErrors.end_sal_col"
                         danger-text="Заполните номер колонки"

              />
            </div>
          </div>
        </div>
        <div class="house-importer-import-saldo-month-panel__actions">
          <app-button color="success" @click="sendFiles">Импортировать</app-button>
        </div>
      </div>
      <div v-else-if="isLoading && !isDone" class="house-importer-import-saldo-month-panel__loading-block">
        <div class="block-loading" />
        <div>Импортируем файл...</div>
      </div>
      <div v-else-if="isDone" class="house-importer-import-saldo-month-panel__done-block">
        <div class="house-importer-import-saldo-month-panel__done-block-icon">
          <app-icon name="CheckIcon" size="120px"/>
        </div>
        <div class="house-importer-import-saldo-month-panel__done-block-text">
          Импорт завершен
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "CheckSaldoPanel",
    props: {
      importInfo: {}
    },
    data() {
      return {
        filesError: false,
        files: [],
        postBody: {
          data_row: null,
          st_sal_col: null,
          end_sal_col: null,
        },
        postBodyErrors: {
          data_row: false,
          st_sal_col: false,
          end_sal_col: false,
        },
        isLoading: false,
        isDone: false
      }
    },
    computed: {
      postBodyHasError(){
        return !!Object.values(this.postBodyErrors).filter(v => v).length;
      }
    },
    methods: {
      resetPostBody() {
        for (let key in this.postBody) {
          if (this.postBody.hasOwnProperty(key)) {
            this.postBody[key] = null;
          }
        }
      },
      resetPostBodyErrors() {
        for (let key in this.postBodyErrors) {
          if (this.postBodyErrors.hasOwnProperty(key)) {
            this.postBodyErrors[key] = false;
          }
        }
      },
      onFilesChange(event, files) {
        this.files = files.filter(file => !file.remove);
        this.filesError = false;
      },
      onFilesDelete(file) {
        const index = this.files.indexOf(file);
        if (index > -1) {
          this.files.splice(index, 1);
          this.filesError = false;
        }
      },
      checkParams(){
        for (let key in this.postBody) {
          if (this.postBody.hasOwnProperty(key) && this.postBody[key] === null) {
            this.postBodyErrors[key] = true;
          }
        }
      },
      async sendFiles(){
        if(!this.files.length){
          this.filesError = true;
        }
        this.checkParams();
        if(this.filesError || this.postBodyHasError) return false;

        let body = Object.assign({import_id: this.importInfo.id, salary_checks: this.files}, this.postBody);

        let bodyFormData = new FormData();

        for(let key in body){
          if(body.hasOwnProperty(key)){
            if(Array.isArray(body[key])){
              for(let i = 0; i < body[key].length; i++){
                bodyFormData.append(`${key}[${i}]`, body[key][i]);
              }
            }
            else{
              bodyFormData.append(key, body[key])
            }
          }
        }

        try{
          this.isLoading = true;

          let {data} = await this.$http.post('/import/houses/upload_salary_checks', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });

          if(data === 'uploaded'){
            this.isLoading = false;
            this.isDone = true;
            this.$vs.notify({color: 'success', title: 'Импорт завершен', text: 'Импорт сальдо завершен'});
          }
          else{
            this.isLoading = false;
            this.isDone = false;
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.isLoading = false;
        }
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-saldo-month-panel {
    .app-panel__body{
      min-height: 270px;
      position: relative;
    }

    &__uploader {
      &_single {
        width: 100%;
        height: 100%;

        .con-img-upload {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .img-upload {
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive span {
              font-size: 16px;
              word-break: break-all;
            }
          }
        }
      }

      &_multiple {
        .con-img-upload {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;

          .img-upload {

            margin: 5px;
            width: 100px;
            height: 100px;
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive {
              i {
                font-size: 5rem;
              }

              span {
                font-size: 12px;
                word-break: break-all;
              }
            }
          }
        }

        .con-input-upload {
          width: 100px;
          height: 100px;
          margin: 5px;

          .text-input {
            font-size: 12px;
            min-width: 100px;
            line-height: 1.1;
          }
        }
      }
    }

    &__no-file-error {
      text-align: center;
      font-size: 11px;
      text-transform: uppercase;
      color: rgba(var(--app-danger), 1);
      font-weight: 600;
    }

    &__main-content {
      display: flex;
      /*align-items: center;*/
      margin: 0 -7.5px;
      height: 100%;
    }

    &__actions{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__panel-col {
      padding: 0 15px;
    }

    &__panel-file {
      border-right: 1px solid rgba(0, 0, 0, .2);
      flex-shrink: 0;
      flex-basis: 50%;
      display: flex;
      flex-direction: column;
    }

    &__panel-settings {
      flex: 1;

      &-row {
        margin-bottom: 15px;
      }
    }

    &__loading-block{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading{
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }

    &__done-block{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-success), 1);

      &-icon{
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text{
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
</style>